import {Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import type {ExamModule} from '@cp/model';

export type SessionStatus = 'all' | 'active' | 'completed';
type ModuleFilter = 'all' | string;

export interface SessionsFiltersProps {
  statusFilter: SessionStatus;
  moduleFilter: ModuleFilter;
  examModules: ExamModule[];
  onStatusFilterChange: (event: SelectChangeEvent<SessionStatus>) => void;
  onModuleFilterChange: (event: SelectChangeEvent<ModuleFilter>) => void;
}

export default function SessionsFilters({
  statusFilter,
  moduleFilter,
  examModules,
  onStatusFilterChange,
  onModuleFilterChange,
}: SessionsFiltersProps) {
  return (
    <Box sx={{mb: 3}}>
      <Box sx={{display: 'flex', gap: 2, flexWrap: 'wrap'}}>
        <Box sx={{minWidth: 200, flex: 1}}>
          <FormControl fullWidth>
            <InputLabel>Status</InputLabel>
            <Select value={statusFilter} label="Status" onChange={onStatusFilterChange}>
              <MenuItem value="all">All Sessions</MenuItem>
              <MenuItem value="active">Active Sessions</MenuItem>
              <MenuItem value="completed">Completed Sessions</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box sx={{minWidth: 200, flex: 1}}>
          <FormControl fullWidth>
            <InputLabel>Module</InputLabel>
            <Select value={moduleFilter} label="Module" onChange={onModuleFilterChange}>
              <MenuItem value="all">All Modules</MenuItem>
              {examModules.map((module) => (
                <MenuItem key={module.id} value={module.id}>
                  {module.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
}
